import React from 'react'
import { Link } from 'react-router-dom'
import { Form } from 'react-bootstrap'

const LoginForm = ({ handleChange, handleSubmit, inputs, isDisable }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group size='lg' controlId='Usuario'>
        <Form.Label className='form__labels'>Email</Form.Label>
        <Form.Control
          className='user-input'
          name='Email'
          type='email'
          value={inputs.Email}
          onChange={handleChange}
          placeholder='Email'
        />
      </Form.Group>
      <Form.Group size='lg' controlId='Password'>
        <Form.Label className='form__labels'>Password</Form.Label>
        <Form.Control
          className='user-input'
          name='Password'
          type='password'
          value={inputs.Password || ''}
          onChange={handleChange}
          placeholder='Contraseña'
        />
      </Form.Group>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Link className='forgot-link' to='/forgot'>
          ¿Has olvidado tu contraseña?
        </Link>
        <button
          onClick={handleSubmit}
          disabled={isDisable}
          className='btn-login'
        >
          Go
        </button>
      </div>
    </Form>
  )
}

export default LoginForm
